import logger from "lib/log";
import { call, select } from "redux-saga/effects";
import { WEEKDAYS } from "lib/date";

import {
  getClubBookingByID,
  getClubBookingIDList
} from "state/school_money/selectors";

import BasketItemIssue from "state/school_money/entities/BasketItemIssue";

/**
 * Check for issues with the given basket item.
 * Returns zero or one issues.
 *
 * @param {BasketItem} basketItem
 * @returns {BasketItemIssue | undefined}
 */
export default function* validateBasketItem(basketItem) {
  
  const clubBookingID = basketItem.payload.get("clubBookingID");
  
  if (yield call(isExpired, clubBookingID)) {
    return BasketItemIssue.fromBasketItem(basketItem, "expired");
  }
  
  // get version in basket and version in state to compare
  const newClubBooking = yield select(getClubBookingByID, clubBookingID);
  const oldClubBooking = basketItem.getIn(["payload", "clubBooking"]);
  
  if (areDaysExpired(newClubBooking, oldClubBooking)) {
    return BasketItemIssue.fromBasketItem(basketItem, "expired");
  }
  
  if (haveBookingsChanged(newClubBooking, oldClubBooking)) {
    return BasketItemIssue.fromBasketItem(basketItem, "bookings_changed");
  }
  
}

/**
 * Has this club booking disappeared from state?
 * @returns {boolean}
 */
function* isExpired(clubBookingID) {
  const clubBookingIDList = yield select(getClubBookingIDList);
  return !clubBookingIDList.includes(clubBookingID);
}

/**
 * Have any of the days in this club booking expired since it was added?
 * @returns {boolean}
 */
function areDaysExpired(newClubBooking, oldClubBooking) {
  
  // check weekdays individually
  for (let i = 0; i < WEEKDAYS.length; i++) {
    
    // get old and new values for whether this day is expired
    const newIsExpired = newClubBooking.expired.get(i);
    const oldIsExpired = oldClubBooking.getIn(["expired", i]);
    
    if (newIsExpired && !oldIsExpired) {
      return true;
    }
    
  }
  
  return false;
  
}

/**
 * Have any of the bookings in this club booking changed since it was added?
 * @returns {boolean}
 */
function haveBookingsChanged(newClubBooking, oldClubBooking) {
  
  // check weekdays individually
  for (let i = 0; i < WEEKDAYS.length; i++) {
    
    // get booked session IDs first so we can check for null
    const newBookedSessionID = newClubBooking.bookedSessionIDs.get(i);
    const oldBookedSessionID = oldClubBooking.getIn(["bookedSessionIDs", i]);
    
    // if neither session is booked then that's fine
    if (newBookedSessionID === null && oldBookedSessionID === null) {
      continue;
    }
    
    // OR if either has been unbooked, they can't be the same
    if(newBookedSessionID === null || oldBookedSessionID === null) {
      return true;
    }
    
    // now get the sessions themselves
    const newBookedSession = newClubBooking.sessions.get(newBookedSessionID);
    // toString() here is because the old club booking has come from JSON so
    //   numeric IDs have been converted to strings
    logger.debug(oldBookedSessionID);
    const oldBookedSession = oldClubBooking.getIn(["sessions", oldBookedSessionID.toString()]);
    
    // if the new booked session doesn't exist - problem
    if (!newBookedSession) {
      return true;
    }
    
    // if the sessions aren't identical - problem
    if (!newBookedSession.equals(oldBookedSession)) {
      return true;
    }
  }
  
  return false;
  
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/basketSaga/clubBooking/validateBasketItem.js